import {
  SyncOutlined,
  CheckCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  MinusCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import * as APITypes from "~/API";

export const ReservationStatusTag = ({
  status,
}: {
  status?: APITypes.AmenityReservationStatus | null;
}) => {
  const { t } = useTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = t("None");

  switch (status) {
    case APITypes.AmenityReservationStatus.Pending:
      color = "yellow";
      icon = <ClockCircleOutlined />;
      statusText = t("Pending");
      break;
    case APITypes.AmenityReservationStatus.Approved:
      color = "green";
      icon = <CheckCircleOutlined />;
      statusText = t("Approved");
      break;
    case APITypes.AmenityReservationStatus.Rejected:
      color = "red";
      icon = <StopOutlined />;
      statusText = t("Rejected");
      break;
    case APITypes.AmenityReservationStatus.Canceled:
      color = "orange";
      icon = <CloseCircleOutlined />;
      statusText = t("Cancelled");
      break;
    default:
      color = "gray";
      icon = <MinusCircleOutlined />;
      statusText = t("None");
      break;
  }

  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
